/* eslint-disable */
// tslint:disable
/**
 * Учи.Знания
 * Учи.Знания
 *
 * OpenAPI spec version: 0.0.1-rc.7
 * Contact: team@uchi.ru
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
import { BASE_PATH, COLLECTION_FORMATS, FetchAPI, FetchArgs, BaseAPI, RequiredError, defaultFetch } from "./runtime";
import { Api } from "./models";

export type FactoryFunction<T> = (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) => T;

/**
 * ArticlesApi - fetch parameter creator
 * @export
 */
export const ArticlesApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Получение статьи</p>
		 * @param {string} articleKind <p>Тип статьи</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getArticle(articleKind: string, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'articleKind' is not null or undefined
			if (articleKind === null || articleKind === undefined) {
				throw new RequiredError('articleKind', 'Required parameter articleKind was null or undefined when calling getArticle.');
			}
			let localVarPath = `/articles/{article_kind}`
				.replace('{article_kind}', encodeURIComponent(String(articleKind)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Получение статей по поисковому запросу</p>
		 * @param {string} [q] <p>Поисковой запрос</p>
		 * @param {string} [per] <p>Количество статей в ответе</p>
		 * @param {string} [page] <p>№ страницы</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getArticleBySearch(q: string | undefined, per: string | undefined, page: string | undefined, options: RequestInit = {}): FetchArgs {
			let localVarPath = `/articles/search`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (q !== undefined) {
				localVarQueryParameter.append('q', String(q));
			}

			if (per !== undefined) {
				localVarQueryParameter.append('per', String(per));
			}

			if (page !== undefined) {
				localVarQueryParameter.append('page', String(page));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Получение списка всех статей</p>
		 * @param {string} disciplineKind <p>Тип предмета(math, rus, etc...)</p>
		 * @param {string} [per] <p>Количество статей в ответе</p>
		 * @param {string} [page] <p>№ страницы пагинации</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getArticles(disciplineKind: string, per: string | undefined, page: string | undefined, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'disciplineKind' is not null or undefined
			if (disciplineKind === null || disciplineKind === undefined) {
				throw new RequiredError('disciplineKind', 'Required parameter disciplineKind was null or undefined when calling getArticles.');
			}
			let localVarPath = `/articles`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (disciplineKind !== undefined) {
				localVarQueryParameter.append('discipline_kind', String(disciplineKind));
			}

			if (per !== undefined) {
				localVarQueryParameter.append('per', String(per));
			}

			if (page !== undefined) {
				localVarQueryParameter.append('page', String(page));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Получение данных на &quot;соседние&quot; статьи</p>
		 * @param {string} [articleKind] <p>Идентификатор статьи</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getNearbyArticles(articleKind: string | undefined, options: RequestInit = {}): FetchArgs {
			let localVarPath = `/articles/articles_nearby`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (articleKind !== undefined) {
				localVarQueryParameter.append('article_kind', String(articleKind));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * ArticlesApi - functional programming interface
 * @export
 */
export const ArticlesApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Получение статьи</p>
		 * @param {string} articleKind <p>Тип статьи</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getArticle(articleKind: string, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetArticle200Response> {
			const localVarFetchArgs = ArticlesApiFetchParamCreator(configuration).getArticle(articleKind, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Получение статей по поисковому запросу</p>
		 * @param {string} [q] <p>Поисковой запрос</p>
		 * @param {string} [per] <p>Количество статей в ответе</p>
		 * @param {string} [page] <p>№ страницы</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getArticleBySearch(q: string | undefined, per: string | undefined, page: string | undefined, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetArticleBySearch200Response> {
			const localVarFetchArgs = ArticlesApiFetchParamCreator(configuration).getArticleBySearch(q, per, page, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Получение списка всех статей</p>
		 * @param {string} disciplineKind <p>Тип предмета(math, rus, etc...)</p>
		 * @param {string} [per] <p>Количество статей в ответе</p>
		 * @param {string} [page] <p>№ страницы пагинации</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getArticles(disciplineKind: string, per: string | undefined, page: string | undefined, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetArticles200Response> {
			const localVarFetchArgs = ArticlesApiFetchParamCreator(configuration).getArticles(disciplineKind, per, page, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Получение данных на &quot;соседние&quot; статьи</p>
		 * @param {string} [articleKind] <p>Идентификатор статьи</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getNearbyArticles(articleKind: string | undefined, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetNearbyArticles200Response> {
			const localVarFetchArgs = ArticlesApiFetchParamCreator(configuration).getNearbyArticles(articleKind, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * ArticlesApi - factory interface
 * @export
 */
export const ArticlesApiFactory: FactoryFunction<ArticlesApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new ArticlesApi(configuration, basePath, fetch);
};

/**
 * ArticlesApi - object-oriented interface
 * @export
 * @class ArticlesApi
 * @extends {BaseAPI}
 */
export class ArticlesApi extends BaseAPI {
	/**
	 * <p>Получение статьи</p>
	 * @param {string} articleKind <p>Тип статьи</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getArticle(articleKind: string, options?: RequestInit) {
		return ArticlesApiFp(this.configuration).getArticle(articleKind, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Получение статей по поисковому запросу</p>
	 * @param {string} [q] <p>Поисковой запрос</p>
	 * @param {string} [per] <p>Количество статей в ответе</p>
	 * @param {string} [page] <p>№ страницы</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getArticleBySearch(q: string | undefined, per: string | undefined, page: string | undefined, options?: RequestInit) {
		return ArticlesApiFp(this.configuration).getArticleBySearch(q, per, page, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Получение списка всех статей</p>
	 * @param {string} disciplineKind <p>Тип предмета(math, rus, etc...)</p>
	 * @param {string} [per] <p>Количество статей в ответе</p>
	 * @param {string} [page] <p>№ страницы пагинации</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getArticles(disciplineKind: string, per: string | undefined, page: string | undefined, options?: RequestInit) {
		return ArticlesApiFp(this.configuration).getArticles(disciplineKind, per, page, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Получение данных на &quot;соседние&quot; статьи</p>
	 * @param {string} [articleKind] <p>Идентификатор статьи</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getNearbyArticles(articleKind: string | undefined, options?: RequestInit) {
		return ArticlesApiFp(this.configuration).getNearbyArticles(articleKind, options)(this.fetch, this.basePath);
	}

}
/**
 * DisciplinesApi - fetch parameter creator
 * @export
 */
export const DisciplinesApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Получение дисциплины(предмета)</p>
		 * @param {string} disciplineKind <p>Тип дисциплины(предмета)</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getDiscipline(disciplineKind: string, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'disciplineKind' is not null or undefined
			if (disciplineKind === null || disciplineKind === undefined) {
				throw new RequiredError('disciplineKind', 'Required parameter disciplineKind was null or undefined when calling getDiscipline.');
			}
			let localVarPath = `/disciplines/{discipline_kind}`
				.replace('{discipline_kind}', encodeURIComponent(String(disciplineKind)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Получение списка дисциплин(предметов)</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getDisciplines(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/disciplines`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * DisciplinesApi - functional programming interface
 * @export
 */
export const DisciplinesApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Получение дисциплины(предмета)</p>
		 * @param {string} disciplineKind <p>Тип дисциплины(предмета)</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getDiscipline(disciplineKind: string, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetDiscipline200Response> {
			const localVarFetchArgs = DisciplinesApiFetchParamCreator(configuration).getDiscipline(disciplineKind, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Получение списка дисциплин(предметов)</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getDisciplines(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetDisciplines200Response> {
			const localVarFetchArgs = DisciplinesApiFetchParamCreator(configuration).getDisciplines(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * DisciplinesApi - factory interface
 * @export
 */
export const DisciplinesApiFactory: FactoryFunction<DisciplinesApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new DisciplinesApi(configuration, basePath, fetch);
};

/**
 * DisciplinesApi - object-oriented interface
 * @export
 * @class DisciplinesApi
 * @extends {BaseAPI}
 */
export class DisciplinesApi extends BaseAPI {
	/**
	 * <p>Получение дисциплины(предмета)</p>
	 * @param {string} disciplineKind <p>Тип дисциплины(предмета)</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getDiscipline(disciplineKind: string, options?: RequestInit) {
		return DisciplinesApiFp(this.configuration).getDiscipline(disciplineKind, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Получение списка дисциплин(предметов)</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getDisciplines(options?: RequestInit) {
		return DisciplinesApiFp(this.configuration).getDisciplines(options)(this.fetch, this.basePath);
	}

}

/**
 * We sometimes represent dates as strings (in models) and as Dates (in parameters) so this
 * function converts them both to a string.
 */
function dateToString(value: Date | string | undefined): string | undefined {
	if (value instanceof Date) {
		return value.toISOString();
	} else if (typeof value === 'string') {
		return value;
	} else {
		return undefined;
	}
}
